/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventSmartHoldInfo_org = {
    readonly id: string;
    readonly primaryOrgCalendar: string;
    readonly primaryOrgEmail: string;
    readonly shadowCalendarSettingsErrorable: {
        readonly __typename: "ShadowCalendarSettings";
        readonly shadowCalendarId: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $fragmentRefs": FragmentRefs<"EventSummary_org">;
    readonly " $refType": "EventSmartHoldInfo_org";
};
export type EventSmartHoldInfo_org$data = EventSmartHoldInfo_org;
export type EventSmartHoldInfo_org$key = {
    readonly " $data"?: EventSmartHoldInfo_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventSmartHoldInfo_org">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EventSmartHoldInfo_org",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryOrgCalendar",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryOrgEmail",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "shadowCalendarSettingsErrorable",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shadowCalendarId",
                            "storageKey": null
                        }
                    ],
                    "type": "ShadowCalendarSettings",
                    "abstractKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSummary_org"
        }
    ],
    "type": "Org",
    "abstractKey": null
} as any;
(node as any).hash = '20eeb98f6dcaae45fdfe2aaa05ae629d';
export default node;
